import { UserPreferenceKey } from "../../../../common/api/decimal/methods/user.ts";
import useUserPreference from "./useUserPreference.ts";
import { useMemo } from "react";

// Don't want things randomly appearing/disappearing or varying from component to component.
// Date/time of initial render is great for these purposes
const staticDate = new Date();

/**
 * @return true if the preference was modified more than numDays ago. Does not
 *         consider what the stored value may be
 */
export default function useUserPreferenceDate(
  key: UserPreferenceKey | undefined,
  numDays: number | undefined
) {
  const [_val, _update, _delete, updatedAt] = useUserPreference(key);

  const expiresDate = useMemo(() => {
    if (updatedAt && numDays) {
      const endDate = new Date(updatedAt);
      endDate.setDate(endDate.getDate() + numDays);
      return endDate;
    }
  }, [updatedAt, numDays]);

  return expiresDate ? staticDate > expiresDate : false;
}
